/**
 * Wave Background Component
 * Animated SVG wave pattern for hero sections
 */

import React from 'react';
import { Box, styled, keyframes } from '@mui/material';
import { colors } from '../../theme/colors';

const wave = keyframes`
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(-50%);
  }
`;

const WaveContainer = styled(Box)({
  position: 'absolute',
  bottom: 0,
  left: 0,
  width: '200%',
  height: '200px',
  animation: `${wave} 20s linear infinite`,
  overflow: 'hidden',
});

interface WaveBackgroundProps {
  opacity?: number;
}

export const WaveBackground: React.FC<WaveBackgroundProps> = ({ opacity = 0.1 }) => {
  return (
    <WaveContainer>
      <svg
        viewBox="0 0 1200 120"
        preserveAspectRatio="none"
        style={{
          width: '100%',
          height: '100%',
        }}
      >
        <path
          d="M0,50 C150,80 350,0 600,50 C850,100 1050,20 1200,50 L1200,120 L0,120 Z"
          fill={colors.primary.main}
          fillOpacity={opacity}
        />
        <path
          d="M0,70 C200,100 400,40 600,70 C800,100 1000,40 1200,70 L1200,120 L0,120 Z"
          fill={colors.secondary.main}
          fillOpacity={opacity * 0.5}
        />
      </svg>
    </WaveContainer>
  );
};
